import '@/prototypes/array';

export default {

    name: 'common',
    namespaced: true,

    state: {       
        roles: null
    },

    getters: { 
        roles (state){
            return state.roles;
        }
    },

    mutations: { 
        SET_ROLES (state, roles) {
            state.roles = roles;

            if (!state.roles) return;
        }
    },

    actions: {         
        setRoles ({ commit }, roles) {
            commit('SET_ROLES', roles);
        }
    }   

};